import rest from "@/js/rest";

export const hasLogined = () => rest.get("/login/hasLogined");

export const getCode = (tel) =>
  rest.get("/login/sendLoginSmsVerifyCode?mobile=" + tel);

export const wxLogin = () => rest.get("/login/getWxLoginUrl");
// 获取扫码登录参数
export const getWxLoginUrlParams = () => rest.get("/login/getWxLoginUrlParams");
// 获取扫码绑定参数
export const getWxBindUrlParams = () => rest.get("/login/getWxBindUrlParams");

// 绑定已有账户
export const bindExistsAccount = (params) =>
  rest.post("/account/bindExistsAccount", params);

// 绑定已有账户-手机号
export const bindExistsAccountByMobile = (params) =>
  rest.post("/account/bindExistsAccountByMobile", params);

// 检验绑定账户
export const checkBindAccount = (user) =>
  rest.get("/account/checkBindAccount?username=" + user);

// 发送绑定手机号码验证码
export const sendBindSmsVerifyCode = (tel) =>
  rest.get("/account/sendBindSmsVerifyCode?mobile=" + tel);

// 检验用户号码是否存在
export const checkUsernameUser = (user) =>
  rest.get("/account/checkUsernameUser?username=" + user);

// 检验手机号码是否存在
export const checkMobileUse = (tel) =>
  rest.get("/account/checkMobileUse?mobile=" + tel);

// 完善用户信息
export const completeAccount = (params) =>
  rest.post("/account/completeAccount", params);

// 修改账号电话号码
export const modifyAccountMobile = (params) =>
  rest.post("/account/modifyAccountMobile", params);

// 获取手机号码验证码
export const sendModifyMobileSmsVerifyCode = (tel) =>
  rest.get("/account/sendModifyMobileSmsVerifyCode?mobile=" + tel);

// 需要完善的用户信息
export const completeAccountInfo = () =>
  rest.get("/account/completeAccountInfo");

// 完成完善信息
export const handleComplete = () => rest.post("/account/handleComplete");

// 详细信息
export const getAccountInfo = () => rest.get("/account/getAccountInfo");

// 修改账号密码
export const modifyPassword = (params) =>
  rest.post("/account/modifyPassword", params);

// 修改昵称
export const modifyLoginAccount = (params) => 
  rest.post("/account/modifyLoginAccount", params)

// 解绑手机号
export const unbindMobile = () => rest.put("/account/unbindMobile");

// 解绑微信号
export const unbindWxAccount = () => rest.post("/account/unbindWxAccount");

// 退出登录
export const logout = () => rest.get("/logout");

// 场景域名
export const scenesAndHostname = () => rest.get("/login/scenesAndHostname");

// 确认邀请注册
export const ackInviteRegister = (params) =>
  rest.post("/account/ackInviteRegister", params);
// 查看邀请信息明细
export const queryInviteDetail = (params) =>
  rest.get("/account/queryInviteDetail", params);
